R = require 'ramda'
Bacon = require 'baconjs'

window.dataLayer ||= []

orderStream = new Bacon.Bus

restaurantStore = require './restaurant'

checkout = new Bacon.Bus
purchase = new Bacon.Bus

merchantInfo = Bacon
  .combineTemplate
    merchant_id: restaurantStore.restaurant.map R.prop 'id'
    currency: restaurantStore.locale.map R.prop 'currency'

orderDiscount = (order) ->
  ''

cartsToProducts = (carts) ->
  R.flatten R.map R.pipe(R.prop('items'), R.map(itemToProduct)), carts

itemToProduct = (item) ->
  id: item.id
  name: item.item_name
  variant: item.size_name
  sku: item.barcode
  category: item.menu + " / " + item.category
  price: item.total / 100
  quantity: item.quantity


# GOOGLE ANALYTICS TRACKING
dataLayer.push(require: 'ec')

signPage = (pageType) ->
  dataLayer.push(pageCategory: pageType)

shouldTrackGA = -> !!window.google_tag_manager
checkout
  .filter shouldTrackGA
  .filter R.compose R.not, R.isNil
  .map (order) ->
    checkout:
      actionField:
        step: 2
        option: order.service.id
      products: cartsToProducts(order.carts)
  .onValue (payload) ->
    signPage 'checkout'
    dataLayer.push
      event: 'checkout'
      ecommerce: payload

purchase
  .filter shouldTrackGA
  .filter (order) -> !!order.totals
  .map (order) ->
    purchase:
      actionField:
        id: order.id
        affiliation: order.restaurant.name
        revenue: order.totals.total / 100.0
        tax: order.totals.tax / 100.0
        shipping: order.totals.charges.delivery / 100.0
        coupon: orderDiscount(order)
      products: cartsToProducts(order.carts)
  .onValue (payload) ->
    signPage 'thankyou'
    dataLayer.push
      event: 'purchase'
      ecommerce: payload

# FACEBOOK PIXEL TRACKING
shouldTrackFB = -> !!window.fbq
fbTrack = R.curry (event, payload) ->
  try
    window.fbq 'track', event, payload
  catch err
    console.error "FB Pixel call failed", err

checkout
  .filter shouldTrackFB
  .filter (order) -> !!order.totals
  .map (order) ->
    value: order.totals.total / 100.0
    num_items: cartsToProducts(order.carts).length
  .combine merchantInfo, (payload, merchant) ->
    R.merge payload, merchant
  .onValue fbTrack 'InitiateCheckout'

purchase
  .filter shouldTrackFB
  .filter (order) -> !!order.totals
  .map (order) ->
    value: order.totals.total / 100.0
    num_items: cartsToProducts(order.carts).length
  .combine merchantInfo, (payload, merchant) ->
    R.merge payload, merchant
  .onValue fbTrack 'Purchase'

module.exports =
  recordPurchase: (order) ->
    purchase.push order

  recordCheckout: (order) ->
    checkout.push order
